// extracted by mini-css-extract-plugin
export default {"root":"profile_edit_nav_item___root___a01b67cd","danger":"profile_edit_nav_item___danger___e498bf55","current":"profile_edit_nav_item___current___ebea567e"};